/**
 * Corporate Form Handler - Submits corporate contact form to Google Sheets
 * Includes City, "Where did you hear about us?", UTM tracking fields
 * Redirects to Thank You page after successful submission
 */

(function() {
    'use strict';

    // Configuration
    const CONFIG = {
        googleSheetsURL: 'https://script.google.com/macros/s/AKfycbxrZm1UOqAeHd7uHT6_rxPKPkkIBZTsUUQYPvg9AGOggepJLkZlizmwIZ64hhFGXczC/exec',
        formSelector: '.corporate-form-cover form',
        sheetName: 'Corporate Leads', // Sheet tab name in Google Spreadsheet
        thankYouPage: 'https://www.rabitat.com/pages/corporate-submission', // Redirect after form submission
    };

    // ─── UTM Helper ───────────────────────────────────────────────────────────
    function getUTMParams() {
        const params = new URLSearchParams(window.location.search);
        return {
            utm_source:   params.get('utm_source')   || '',
            utm_medium:   params.get('utm_medium')   || '',
            utm_campaign: params.get('utm_campaign') || '',
            utm_term:     params.get('utm_term')     || '',
            utm_content:  params.get('utm_content')  || '',
        };
    }

    // ─── Init ─────────────────────────────────────────────────────────────────
    function init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', setupForm);
        } else {
            setupForm();
        }
    }

    function setupForm() {
        const form = document.querySelector(CONFIG.formSelector);

        if (!form) {
            return;
        }

        // Phone input validation - only digits, max 10
        const phoneInput = form.querySelector('#corp-phone');
        if (phoneInput) {
            phoneInput.setAttribute('type', 'tel');
            phoneInput.setAttribute('autocomplete', 'off');
            phoneInput.setAttribute('maxlength', '10');
            phoneInput.setAttribute('pattern', '[0-9]{10}');

            phoneInput.addEventListener('input', function() {
                this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10);
            });
        }

        // Email - disable autocomplete
        const emailInput = form.querySelector('#corp-email');
        if (emailInput) {
            emailInput.setAttribute('autocomplete', 'off');
        }

        // ─── Form Submit ───────────────────────────────────────────────────────
        form.addEventListener('submit', async function(e) {
            e.preventDefault();

            // Get form values
            const name      = form.querySelector('#corp-name')?.value.trim()  || '';
            const phone     = form.querySelector('#corp-phone')?.value.trim() || '';
            const email     = form.querySelector('#corp-email')?.value.trim() || '';
            const city      = form.querySelector('#corp-city')?.value.trim()  || '';
            const units     = form.querySelector('#corp-nou')?.value.trim()   || '';
            const inquiry   = form.querySelector('#corp-if')?.value.trim()    || '';
            const heardFrom = form.querySelector('#corp-heard')?.value.trim() || '';
            const message   = form.querySelector('#corp-message')?.value.trim() || '';

            // UTM params captured from URL
            const utms = getUTMParams();

            // ── Validation ──────────────────────────────────────────────────
            if (!name) {
                alert('Please enter your name');
                return;
            }
            if (!phone) {
                alert('Please enter your phone number');
                return;
            }
            if (phone.length !== 10) {
                alert('Phone number must be exactly 10 digits');
                return;
            }
            if (!/^[0-9]{10}$/.test(phone)) {
                alert('Phone number must contain only digits');
                return;
            }
            if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                alert('Please enter a valid email address');
                return;
            }
            if (!city) {
                alert('Please enter your city');
                return;
            }
            if (!units) {
                alert('Please select number of units');
                return;
            }
            if (!inquiry) {
                alert('Please select inquiry type');
                return;
            }
            if (!heardFrom) {
                alert('Please select where you heard about us');
                return;
            }

            // ── Prepare payload ─────────────────────────────────────────────
            const formData = {
                // Form fields
                name:         name,
                phone:        phone,
                email:        email,
                city:         city,
                units:        units,
                inquiry:      inquiry,
                heardFrom:    heardFrom,
                message:      message,

                // UTM / tracking
                landingPage:    window.location.href,
                utm_source:     utms.utm_source,
                utm_medium:     utms.utm_medium,
                utm_campaign:   utms.utm_campaign,
                utm_term:       utms.utm_term,
                utm_content:    utms.utm_content,

                // Meta
                sheetName:  CONFIG.sheetName,
                timestamp:  new Date().toISOString(),
            };

            // ── Submit ──────────────────────────────────────────────────────
            const submitBtn = form.querySelector('button[type="submit"]');
            const originalText = submitBtn ? submitBtn.textContent : '';

            try {
                if (submitBtn) {
                    submitBtn.disabled = true;
                    submitBtn.textContent = 'Submitting...';
                }

                if (CONFIG.googleSheetsURL) {
                    await fetch(CONFIG.googleSheetsURL, {
                        method: 'POST',
                        mode: 'no-cors',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    });

                    // ── Redirect to Thank You page ──────────────────────────
                    window.location.href = CONFIG.thankYouPage;

                } else {
                    console.error('Google Sheets URL not configured for corporate form');
                    alert('Form configuration error. Please contact support.');
                }

            } catch (error) {
                console.error('Corporate form submission error:', error);
                alert('Sorry, there was an error submitting your form. Please try again.');

                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalText;
                }
            }
        });

    }

    // Public API
    window.CorporateFormHandler = {
        setGoogleSheetsURL: function(url) {
            CONFIG.googleSheetsURL = url;
        },
        setSheetName: function(name) {
            CONFIG.sheetName = name;
        },
        setThankYouPage: function(url) {
            CONFIG.thankYouPage = url;
        }
    };

    // Initialize
    init();

})();
